import React, { Component } from "react";
import {browserHistory} from 'react-router-dom'
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from "reactstrap";
import createHistory from 'history/createBrowserHistory'
import  { Redirect } from 'react-router-dom'
import { NavLink } from "react-router-dom";
import CustomModal from "../CustomModal";
import { connect } from "react-redux";
import { updateStatusLogin } from "../../actions/authAction";



class Header extends Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.refresh = this.refresh.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.toggleModalBismart = this.toggleModalBismart.bind(this);
		this.toggleModalsdipbs = this.toggleModalsdipbs.bind(this);
		this.handleLogoutButton = this.handleLogoutButton.bind(this);
		this.handleLogoutButtonBismart = this.handleLogoutButtonBismart.bind(this);
		this.handleLogoutButtonsdipbs = this.handleLogoutButtonsdipbs.bind(this);

		this.state = {
			dropdownOpen: false,
			modalShow: false,
			modalShowBismart: false,
			modalShowsdipbs: false,
			user_kodesekolah:localStorage.SECOLAH_CODE,
			idsekolah:localStorage.IDBISMART
		};
	}

	toggle() {
		this.setState({
			dropdownOpen: !this.state.dropdownOpen
		});
	}

	toggleModalBismart() {
		this.setState({
			modalShowBismart: !this.state.modalShowBismart,

		});

	}
	toggleModalsdipbs() {
		this.setState({
			modalShowsdipbs: !this.state.modalShowsdipbs,

		});

	}

	toggleModal() {
		this.setState({
			modalShow: !this.state.modalShow,

		});
	}

	handleLogoutButton() {
		this.props.dispatch(updateStatusLogin(false, "", "", "", "", "", ""));
		localStorage.clear();
	}

	handleLogoutButtonBismart() {
		this.props.dispatch(updateStatusLogin(false, "", "", "", "", "", ""));
		localStorage.clear();
		// window.location.replace('https://sekolah.sismart.id?login?redirect=&kode=smkbnif&id=sekolah');
		// window.location.reload("http://localhost:3000/#/login?redirect=&kode=smkbnif&id=sekolah");


		const history = createHistory();
		history.push('/#/login?redirect=%2F&kode=smkbnif&id=sekolah');
		history.go(0);
	}

	handleLogoutButtonsdipbs() {
		this.props.dispatch(updateStatusLogin(false, "", "", "", "", "", ""));
		localStorage.clear();
		// window.location.replace('https://sekolah.sismart.id?login?redirect=&kode=smkbnif&id=sekolah');
		// window.location.reload("http://localhost:3000/#/login?redirect=&kode=smkbnif&id=sekolah");


		const history = createHistory();
		history.push('/#/login?redirect=%2F&kode=sdipbs&id=sekolah');
		history.go(0);
	}

	async refresh(){
		window.location.reload();
	}


	sidebarToggle(e) {
		e.preventDefault();
		document.body.classList.toggle("sidebar-hidden");
	}

	sidebarMinimize(e) {
		e.preventDefault();
		document.body.classList.toggle("sidebar-minimized");
	}

	mobileSidebarToggle(e) {
		e.preventDefault();
		document.body.classList.toggle("sidebar-mobile-show");
	}

	asideToggle(e) {
		e.preventDefault();
		document.body.classList.toggle("aside-menu-hidden");
	}

	render() {
		return (
			<header className="app-header navbar">
				<CustomModal
					modalHeaderText="Logout"
					modalBodyText="Anda yakin sudah selesai dan ingin keluar?"
					modalSubmitText="Ya"
					handleSubmit={this.handleLogoutButton}
					toggleModal={this.toggleModal}
					isShow={this.state.modalShow}
				/>

				<CustomModal
					modalHeaderText="Logout"
					modalBodyText="Anda yakin sudah selesai dan ingin keluar dari Bismart?"
					modalSubmitText="Ya"
					handleSubmit={this.handleLogoutButtonBismart}
					toggleModal={this.toggleModalBismart}
					isShow={this.state.modalShowBismart}
				/>

				<CustomModal
					modalHeaderText="Logout"
					modalBodyText="Anda yakin sudah selesai dan ingin keluar?"
					modalSubmitText="Ya"
					handleSubmit={this.handleLogoutButtonsdipbs}
					toggleModal={this.toggleModalsdipbs}
					isShow={this.state.modalShowsdipbs}
				/>

				<button
					className="navbar-toggler mobile-sidebar-toggler d-lg-none"
					type="button"
					onClick={this.mobileSidebarToggle}
				>
					&#9776;
				</button>


				{this.state.user_kodesekolah === "smkbnif"  ? (
					// eslint-disable-next-line
					<a className="navbar-brand-2" href="" />
				) :this.state.user_kodesekolah === "sdipbs"  ? (
						// eslint-disable-next-line
						<a className="navbar-brand-3" href="" />):
					( <a className="navbar-brand" href="" />
				)}
				<ul className="nav navbar-nav d-md-down-none">
					<li className="nav-item">
						<button
							className="nav-link navbar-toggler sidebar-toggler"
							type="button"
							onClick={this.sidebarToggle}
						>
							&#9776;
						</button>
					</li>

				</ul>
				<a className="nav-item" ><strong id="nm_sekolah" >{localStorage.NMSEKOLAH}</strong></a>

				<ul className="nav navbar-nav ml-auto">
					<button

						className="btn btn-sm btn-primary-3 float-right"
						onClick={this.refresh}
						type="button"
					>
						<strong className="font-sm">Refresh</strong> <i className="fa fa-refresh"> </i>
					</button>
					<li className="nav-item">


						<Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
							<Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
								<DropdownToggle  caret style={{ marginRight: "25px" }}>
									Account
									<img></img>
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem header>Account</DropdownItem>

									<li className="nav-item" ><strong id="nm_user">{localStorage.SISMART_USER_NAMA}</strong></li>
									<li className="nav-item" ><strong >{localStorage.SISMART_USER_LEVEL}</strong></li>
									<NavLink to="/profil">
										<DropdownItem>
											<i className="fa fa-user" /> Profil
										</DropdownItem>
									</NavLink>

									{this.state.user_kodesekolah === "sdipbs"  ? (
										<DropdownItem onClick={this.toggleModalsdipbs}>
											<i className="fa fa-lock" /> Logout
										</DropdownItem>
									) :this.state.user_kodesekolah === "smkbnif"  ? (
										<DropdownItem onClick={this.toggleModalBismart}>
											<i className="fa fa-lock" /> Logout
										</DropdownItem>
									) : ( <DropdownItem onClick={this.toggleModal}>
											<i className="fa fa-lock" /> Logout
										</DropdownItem>
									)}

								</DropdownMenu>
							</Dropdown>
						</Dropdown>
					</li>
				</ul>
			</header>
		);
	}
}

export default connect()(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js